const routerPaths = {
  root: "/",
  autzen: "/demos/autzen",
  bristol: "/demos/bristol",
  santorini: "/demos/santorini",
};

export default routerPaths;
